<template>
  <v-form ref="fm_membership_info">
      <v-card outlined tile elevation="2" class="mt-2">
          <v-card-title class="font-weight-light mb-2 pb-0">Dues Payment Information</v-card-title>
          <v-card-subtitle class="py-0 pt-2">
            Information on dues amounts, which are subject to change each year, is available at <a class="text-decoration-none" style="color:rgba(0,0,0,.6)" href="https://mea.org/dues-information/" target="_blank">https://mea.org/dues-information/</a>
          </v-card-subtitle>
          <v-card-text>
            <v-row v-if="applicationIsIbl">
                <v-col cols="12">
                    <v-radio-group
                        ref="oma_pmt_type_id"
                        v-model="oma_pmt_type_id"
                        :rules="rules.oma_pmt_type_id"
                    >
                        <v-radio
                            value="ibl_eft"
                            class="d-flex align-start label-100"
                        >
                            <template #label>
                                <div class='d-flex flex-column'>
                                    <v-row>
                                        <v-col cols="12">
                                            <font-awesome-icon icon="university" size="lg" class="mr-2"></font-awesome-icon> ACH (RECOMMENDED)
                                        </v-col>
                                    </v-row>                                                                          
                                    <ibl-eft ref="eft" v-if="oma_pmt_type_id === 'ibl_eft'"></ibl-eft>                                                
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="ibl_credit_card"
                            class="d-flex align-start label-100"
                            width="100%"
                        >
                            <template #label>
                                <div class='d-flex flex-column' width="100%">
                                    <v-row>
                                        <v-col cols="12">
                                            <font-awesome-icon icon="credit-card" size="lg" class="mr-2"></font-awesome-icon> Credit Card
                                        </v-col>
                                    </v-row> 
                                    <ibl-credit-card ref="credit_card" v-if="oma_pmt_type_id == 'ibl_credit_card'" ></ibl-credit-card> 
                                </div>                                
                            </template>
                        </v-radio>
                        <v-radio
                            value="ibl_cash_check"
                            class="d-flex align-start label-100"
                        >
                            <template #label>                                
                                <div class='d-flex flex-column'>
                                    <v-row>
                                        <v-col cols="12">
                                            <font-awesome-icon icon="money-bill-wave-alt" size="lg" class="mr-2"></font-awesome-icon> Cash/Personal Check
                                        </v-col>
                                    </v-row>                            
                                    <ibl-cash-check v-if="oma_pmt_type_id == 'ibl_cash_check'"></ibl-cash-check>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-col>               
            </v-row>
            <v-row v-else-if="applicationIsIpdd">
                <v-col cols="12">
                    <v-radio-group
                        ref="oma_pmt_type_id"
                        v-model="oma_pmt_type_id"
                        :rules="rules.oma_pmt_type_id"
                    >
                        <v-radio
                            value="ipdd_payroll_deduct"
                            class="d-flex align-start label-100"
                            v-if="!applicationEduesOnly"
                        >
                            <template #label>
                                <div class='d-flex flex-column'><v-row>
                                    <v-col cols="12">
                                            Payroll Dues Deduction
                                        </v-col>
                                    </v-row> 
                                    <ipdd-payroll-deduct 
                                        v-if="oma_pmt_type_id == 'ipdd_payroll_deduct'"
                                        :HasAuthForm="$store.state.oma_barg_unit_detail.org_ippd_authorization_type_ext != null"
                                        :FormType="$store.state.oma_barg_unit_detail.org_ippd_authorization_type_ext"
                                        :FormPath="$store.state.oma_barg_unit_detail.org_ippd_authorization_path_ext"
                                        :UnitKey="$store.state.oma_barg_unit_detail.unit_key"
                                    ></ipdd-payroll-deduct>                                              
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="ipdd_eft"
                            class="d-flex align-start label-100"
                            v-if="!applicationPayrollDeductOnly"
                        >
                            <template #label>
                                <div class='d-flex flex-column'>
                                    <v-row>
                                        <v-col cols="12">
                                            eDues via Billhighway with ACH Autopay
                                        </v-col>
                                    </v-row>                                                                          
                                    <ibl-eft ref="eft" v-if="oma_pmt_type_id === 'ipdd_eft'"></ibl-eft>                                                
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="ipdd_credit_card"
                            class="d-flex align-start label-100"
                            width="100%"
                            v-if="!applicationPayrollDeductOnly"
                        >
                            <template #label>
                                <div class='d-flex flex-column' width="100%">
                                    <v-row>
                                        <v-col cols="12">
                                            eDues via Billhighway with Credit Card Autopay
                                        </v-col>
                                    </v-row> 
                                    <ibl-credit-card ref="credit_card" v-if="oma_pmt_type_id == 'ipdd_credit_card'" ></ibl-credit-card> 
                                </div>                                
                            </template>
                        </v-radio>
                        <v-radio
                            value="ipdd_cash_check"
                            class="d-flex align-start label-100"
                            v-if="!applicationPayrollDeductOnly"
                        >
                            <template #label>                                
                                <div class='d-flex flex-column'>
                                    <v-row>
                                        <v-col cols="12">
                                            eDues via Billhighway with Cash/Personal Check
                                        </v-col>
                                    </v-row>                            
                                    <ibl-cash-check v-if="oma_pmt_type_id == 'ipdd_cash_check'"></ibl-cash-check>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-col>               
            </v-row>
            <v-row
                v-else-if="lblHasPayrollDeduct"
            >
                <v-col cols="12">
                    <v-radio-group
                        ref="oma_pmt_type_id"
                        v-model="oma_pmt_type_id"
                        :rules="rules.oma_pmt_type_id"
                    >
                        <v-radio
                            value="lbl_payroll_deduct"
                            class="d-flex align-start label-100"
                        >
                            <template #label>
                                <div class='d-flex flex-column'><v-row>
                                    <v-col cols="12">
                                            Payroll Deduction (RECOMMENDED)
                                        </v-col>
                                    </v-row> 
                                    <lbl-payroll-deduct v-if="oma_pmt_type_id == 'lbl_payroll_deduct'"></lbl-payroll-deduct>                                              
                                </div>
                            </template>
                        </v-radio>                        
                        <v-radio
                            value="lbl_check_cash"
                            class="d-flex align-start label-100"
                        >
                            <template #label>                                
                                <div class='d-flex flex-column'>
                                    <v-row>
                                        <v-col cols="12">
                                            Cash/Personal Check
                                        </v-col>
                                    </v-row>                            
                                    <lbl-cash v-if="oma_pmt_type_id == 'lbl_check_cash'"></lbl-cash>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12">
                    <v-radio-group
                        ref="oma_pmt_type_id"
                        v-model="oma_pmt_type_id"
                        :rules="rules.oma_pmt_type_id"
                    >
                        <v-radio
                            value="lbl_custom"
                            class="d-flex align-start label-100"
                        >
                            <template #label>
                                <div class='d-flex flex-column'><v-row>
                                    <v-col cols="12">
                                        I will work with my local to set up dues payments        
                                    </v-col>
                                    </v-row> 
                                    <lbl-custom v-if="oma_pmt_type_id == 'lbl_custom'"></lbl-custom>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>           
          </v-card-text>
      </v-card>      
      <v-card outlined tile elevation="2" class="mt-2">
          <v-card-title class="font-weight-light mb-2 pb-0">All Inclusive Membership (AIM) In MEA/NEA-Retired</v-card-title>
          <v-card-text>
            <v-row>                
                <v-col cols="12" class="py-0 pt-2">
                    All members of MEA/NEA are automatically enrolled in MEA/NEA-Retired unless the box below is checked. The AIM fee is in addition to MEA/NEA dues.
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" class="py-0">
                    <v-checkbox
                        ref="oma_mear_opt_out_ind"
                        v-model="oma_mear_opt_out_ind"
                        value="1"
                        @change="update_app_record('oma_mear_opt_out_ind')"
                        label="I do not wish to join MEA/NEA-Retired at this time. I understand that I will not be eligible for any of the benefits of membership in MEA/NEA-Retired."
                    ></v-checkbox>
                </v-col>
            </v-row>            
          </v-card-text>
      </v-card>    
      <v-row class="justify-center">
        <v-col cols="12" class="d-flex flex-column flex-md-row justify-space-between">
            <v-btn
                color="grey darken-3"
                tile
                @click="$emit('go-back')"
                dark
                class='my-2'
            >
                Go Back
            </v-btn>

            <v-btn
                color="rgb(0 48 87)"
                tile
                @click="validate_and_continue"
                dark
                class='my-2'
            >
                Continue to Step 4
            </v-btn>
        </v-col>
    </v-row>
    <saving-progress-dialog :showDialog="showSavingProgress"></saving-progress-dialog>
    <error-dialog :showDialog="showError" :errorObject="errorObj" :errorIsFatal="errorIsFatal" @close-dialog="showError=false"></error-dialog>
    <errors-on-form-dialog :showDialog="showErrorsOnForm" @close-dialog="showErrorsOnForm=false;"></errors-on-form-dialog>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import IblEft from './paymentMethod/IblEft.vue'
  import IblCreditCard from './paymentMethod/IblCreditCard.vue';
  import IblCashCheck from './paymentMethod/IblCashCheck.vue';
  import IpddPayrollDeduct from './paymentMethod/IpddPayrollDeduct.vue';
  import LblCash from './paymentMethod/LblCash.vue';
  import LblPayrollDeduct from './paymentMethod/LblPayrollDeduct.vue';
  import LblCustom from './paymentMethod/LblCustom.vue';
  import SavingProgressDialog from './DialogComponents/SavingProgressDialog.vue' ;
  import ErrorDialog from './DialogComponents/ErrorDialog.vue';
  import ErrorsOnFormDialog from './DialogComponents/ErrorsOnFormDialog.vue';
  import commonMixins from '@/mixins/commonMixins';

  export default {
  components: { 
        IblEft, IblCreditCard, IblCashCheck, LblPayrollDeduct, LblCash, 
        LblCustom, IpddPayrollDeduct, SavingProgressDialog, ErrorDialog, ErrorsOnFormDialog
    },
    name: 'MembershipInfo',
    mixins:[commonMixins],
    data:() => ({        
        showSavingProgress: false,
        showErrorsOnForm:false,
        errorObj: {},
        showError: false,
        errorIsFatal:false,
        rules:{
            oma_pmt_type_id:[
                v => !!v || 'Payment Type is required',
                v => /^[a-z_]+$/.test(v) || 'Payment Type is invalid'
            ]
        }    
    }),
    methods:{         
        async validate_and_continue(){
            if(!this.$refs.fm_membership_info.validate()) return false;
            this.showSavingProgress = true;

            // get all the form data to update the db
            const formData = {
                doCmd: 'update_db',
                app_id: window.sessionStorage.getItem('appID'),
                oma_pmt_type_id : this.oma_pmt_type_id,
                oma_mear_opt_out_ind: this.oma_mear_opt_out_ind
            }
            this.log_activity(`Attempting to update database with membership info`);
            
            let endpoint = '';
            const tokenize_pmt_payload = {mapid: window.sessionStorage.getItem('appID')};
            if(['ibl_credit_card', 'ibl_eft', 'ipdd_credit_card', 'ipdd_eft'].includes(this.$store.state.oma_pmt_type_id)){                
                if(['ipdd_credit_card', 'ibl_credit_card'].includes(this.$store.state.oma_pmt_type_id)){
                    if(!this.$refs.credit_card.$refs.fm_credit_card.validate()){
                        this.showErrorsOnForm = true;
                        this.showSavingProgress = false;
                        return false;
                    }
                    endpoint = 'ccverify';
                    //tokenize payment info for BH                                        
                    tokenize_pmt_payload['NameOnCard'] = formData['oma_cc_cardholder_name'] = this.$store.state.oma_cc_cardholder_name; // {# Maximum 100 characters #}
                    // determine which values to use for billing address
                    const same = this.$store.state.oma_cc_bill_addr_alt_ind != '1';
                    formData['oma_cc_bill_addr_alt_ind'] = this.$store.state.oma_cc_bill_addr_alt_ind;
                    if(!same){
                        tokenize_pmt_payload['Address1'] = formData['oma_cc_bill_addr_alt_street_line1'] = this.$store.state.oma_cc_bill_addr_alt_street_line1;
                        tokenize_pmt_payload['Address2'] = formData['oma_cc_bill_addr_alt_street_line2'] =this.$store.state.oma_cc_bill_addr_alt_street_line2;
                        tokenize_pmt_payload['City'] = formData['oma_cc_bill_addr_alt_city'] = this.$store.state.oma_cc_bill_addr_alt_city;
                        tokenize_pmt_payload['State'] = formData['oma_cc_bill_addr_alt_state_code'] = this.$store.state.oma_cc_bill_addr_alt_state_code;
                        tokenize_pmt_payload['PostalCode'] = formData['oma_cc_bill_addr_alt_zip'] = this.$store.state.oma_cc_bill_addr_alt_zip;
                    }else{
                        tokenize_pmt_payload['Address1'] = this.$store.state.oma_street_address1; // {# Maximum 100 characters #}
                        tokenize_pmt_payload['Address2'] = this.$store.state.oma_street_address2; // {# <-- optional,  Maximum 100 characters #}
                        tokenize_pmt_payload['City'] = this.$store.state.oma_city; // {# Maximum 100 characters #}
                        tokenize_pmt_payload['State'] = this.$store.state.oma_state; // {# 2 characters #}
                        tokenize_pmt_payload['PostalCode'] = this.$store.state.oma_zip; // {# max 10 characters #}
                    
                    }

                    tokenize_pmt_payload['Country'] = 'USA';
                    tokenize_pmt_payload['PreferredEmailAddress'] = this.$store.state.oma_home_email; // {# <-- optional, Maximum 100 characters #}
                    tokenize_pmt_payload['CardNumber'] = formData['oma_cc_num'] = this.$store.state.oma_cc_num.replace(/[ ]/g, '');
                    tokenize_pmt_payload['ExpMonth'] = formData['oma_cc_exp_month'] = this.$store.getters.getCCExpMonth; // {# 1-12 #}
                    tokenize_pmt_payload['ExpYear'] = formData['oma_cc_exp_year'] = this.$store.getters.getCCExpYear; // {# 4-digit #}
                    tokenize_pmt_payload['Cvv'] = formData['oma_pmt_cc_sec_num'] = this.$store.state.oma_pmt_cc_sec_num; // {# 4-digit amex, 3-digit all other types #}
                    formData['oma_pmt_cc_num_last4'] = this.$store.getters.getCCLast4;
                    formData['oma_pmt_cc_card_type_name'] = this.$store.state.oma_pmt_cc_card_type_name;
                    tokenize_pmt_payload['Amount'] = '0.00' // {# decimal 8,2 #}					
                }else if(['ibl_eft', 'ipdd_eft'].includes(this.$store.state.oma_pmt_type_id) ){
                    if(!this.$refs.eft.$refs.fm_eft.validate()){
                        this.showErrorsOnForm = true;
                        this.showSavingProgress = false;
                        return false;
                    }
                    endpoint = 'achverify';
                    formData['oma_pmt_eft_bank_name'] = this.$store.state.oma_pmt_eft_bank_name;
                    formData['oma_pmt_eft_act_type'] = this.$store.state.oma_pmt_eft_act_type;
                    formData['oma_pmt_eft_act_holder_name'] = this.$store.state.oma_pmt_eft_act_holder_name;
                    tokenize_pmt_payload['BankAccount'] = formData['oma_pmt_eft_act_num'] = this.$store.state.oma_pmt_eft_act_num;
                    tokenize_pmt_payload['RoutingNumber'] = formData['oma_pmt_eft_route_num'] = this.$store.state.oma_pmt_eft_route_num;
                    formData['oma_pmt_eft_act_num_last4'] = this.$store.getters.getEFTActLast4;
                }                               
            }

            const update_db = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(formData), {
                headers : {'Content-Type': 'application/json'}
            });

            if(update_db.data.result.has_error){
                this.showError = true;
                let errors = [];
                update_db.data.result.fail.forEach(v => errors.push(`REF# ${v.errorref} - ${v.errortext} <br/>`))
                this.errorObj = {errorref:false, errortext:errors.join('')};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }

            if(update_db.data.error > 0){
                this.showError = true;
                this.errorObj = {errorref:update_db.data.errorref, errortext:update_db.data.errortext};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }

            if(['ibl_credit_card', 'ibl_eft', 'ipdd_credit_card', 'ipdd_eft'].includes(this.$store.state.oma_pmt_type_id)){
                this.log_activity(`Attempting to tokenize payment method (${this.$store.state.oma_pmt_type_id})`);
                tokenize_pmt_payload['doCmd'] = 'tokenize_payment_method';
                tokenize_pmt_payload['endpoint'] = endpoint;
                const tokenize_payment = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(tokenize_pmt_payload), {
                    headers : {'Content-Type': 'application/json'}
                });

                delete tokenize_payment.data.results.inputdata;
                if(tokenize_payment.data.results.RawResponse){
                    tokenize_payment.data.results.RawResponse = '';
                }
                const log_response = await this.log_activity('BH Tokenization Response', tokenize_payment.data);
                
                if(tokenize_payment.data.error > 0){
                    this.showError = true;
                    const displayErrorText = /^Billhighway Message/i.test(tokenize_payment.data.errortext)?tokenize_payment.data.errortext:'An unexpeced error occured';
                    this.errorObj = {errorref:log_response.data.errorref??false,errortext:displayErrorText.replace(/^Billhighway Message:/i,'')};
                    this.errorIsFatal = false;
                    this.showSavingProgress = false;
                    return;
                }

                const {CardRef, AchRef} = tokenize_payment.data.results;
                this.oma_pmt_token = CardRef ?? AchRef;
                this.oma_pmt_token_response = JSON.stringify(tokenize_payment.data.results);
                this.update_app_record('oma_pmt_token');
                this.update_app_record('oma_pmt_token_response');
            }

            //clear out any values that aren't associated with the selected payment type
            const clear_payload = {doCmd:'clear_pmt_det', app_id:window.sessionStorage.getItem('appID'), pmt_type:this.$store.state.oma_pmt_type_id};
            const clear_pmt_data = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(clear_payload))
            //clear out the values that were cleared by the server in the store
            clear_pmt_data.data.result.forEach(c=>{
                this.$store.state[c] = null;
            });
            

            const update_step_payload = {doCmd:'update_app_step', app_id: window.sessionStorage.getItem('appID'), number: 3 };
            const update_app_step = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(update_step_payload), {
                headers : {'Content-Type': 'application/json'}
            });

            const {data: {error:uas_error, errortext:uas_errortext}} = update_app_step;
            if(uas_error > 0){
                this.showError = true;
                this.ErrorObj = {error:uas_error, errortext:uas_errortext};
                this.errorIsFatal = false;
            }
    
            this.showSavingProgress = false;
            this.$emit('next-step');
        },
        
    },    
    computed:{
        applicationIsIbl: function(){
            return this.$store.state.oma_barg_unit_detail.is_ibl == '1' && this.$store.state.oma_barg_unit_detail.is_ipdd != '1';
        },
        applicationIsIpdd: function(){
            return this.$store.state.oma_barg_unit_detail.is_ipdd == '1';
        },
        applicationEduesOnly: function(){
            return this.$store.state.oma_barg_unit_detail?.edues_only == '1';
        },
        applicationPayrollDeductOnly: function(){
            return this.$store.state.oma_barg_unit_detail?.payroll_deduct_only == '1';
        },
        lblHasPayrollDeduct: function(){
            return this.$store.state.oma_barg_unit_detail.has_payroll_deduct == '1';
        },
        oma_pmt_type_id:{
            get(){
                return this.$store.state.oma_pmt_type_id;
            },
            set(value){
                this.$store.state.oma_pmt_type_id = value;
            }
        },
        oma_mear_opt_out_ind:{
            get(){
                return this.$store.state.oma_mear_opt_out_ind;
            },
            set(value){
                this.$store.state.oma_mear_opt_out_ind = value;
            }
        },        
        oma_pmt_token:{
            get(){
                return this.$store.state.oma_pmt_token;
            },
            set(value){
                this.$store.state.oma_pmt_token = value;
            } 
        },
        oma_pmt_token_response:{
            get(){
                return this.$store.state.oma_pmt_token_response;
            },
            set(value){
                this.$store.state.oma_pmt_token_response = value;
            } 
        }
    }
  }
</script>

<style>
.label-100 .v-label{
    width:100%;
    display:inline-block !important;
}
</style>